import styled from '@emotion/styled';
import React from 'react';
import { Box } from '~Styles';

interface TabProps {
  active?: boolean;
}

export const Tab = styled(Box)<TabProps>`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 4px;
  border: ${({ active }) =>
    active ? '2px solid var(--colorWhite)' : '2px solid var(--colorBlueGray900)'};
  cursor: pointer;
  transition: all 0.15s ease-out;
  font-weight: ${({ active }) => (active ? 600 : 400)};
  letter-spacing: 0.24px;
  font-size: 16px;
  color: ${({ active }) => (active ? 'var(--colorWhite)' : 'var(--colorBlueGray200)')};

  &:active {
    transform: scale(0.94);
  }
`;

Tab.defaultProps = {
  padding: 'small',
};

interface TabsProps {
  children: React.ReactNode;
}

export const Tabs = ({ children }: TabsProps) => {
  return (
    <Box
      display="inline-flex"
      gap="small"
      marginBottom={'small'}
      style={{ position: 'relative', overflow: 'hidden' }}>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child as React.ReactElement<any>, { key: index }),
      )}
    </Box>
  );
};

export default Tabs;
